import { useMutation } from '@apollo/client';
import { CREATE_ASSET } from '../gql/mutations';
import { v4 as uuidv4 } from 'uuid';

export const useCreateURLAsset = () => {
    const [ createAsset ] = useMutation( CREATE_ASSET );
    
    const createURLAsset = async ( { name, url } ) => {
        const uuid = uuidv4();

        try {
            const variables = {
                'input': {
                    id: uuid,
                    type: 'URL',
                    name: name,
                    url: url
                }
            };
            
            const response = await createAsset( { variables } );
            const success = !( response?.error || response?.errors && response?.errors?.length > 0 );
            
            if ( success && response?.data?.result?.url ) {
                return uuid;
            } else {
                console.error( 'Error at createURLAsset' );
                return { error: true };
            } 
        } catch ( error ) { 
            console.error( 'Error at createURLAsset', error );
            return { error: true };
        }     
    };

    return {
        createURLAsset
    };
};
